import React, { useEffect, useRef, useState, dispatch } from "react";
import mobileModal from "./../../img/icons/mobile-modal.svg";
import filterIcon from "./../../img/icons/filter-icon.svg";
import closeIcon from "./../../img/icons/close-m.svg";
import accordionScrollImg from "./../../img/icons/Accordion-stickyscroll-icon.svg";
import { useSelector } from "react-redux";
import { AddMyAnalogModalIcon } from "../AddToMyAnalogIcon/AddToMyAnalogIcon";
import Share from "../Share";
import ExcelDownload from "../ExcelDownload";
import localization from "../../data/config";
import SortBy from "../SortBy";
import QuickFilter from "../QuickFilter/QuickFilter";
import QuickFilterError from "../QuickFilterError/QuickFilterError";
import { debounce } from "../../utilities/parameters";
import "./style.css";
import Tools from "./Tools";

/**
 * @name FeatureMobileLayout
 * @function
 * @description Displays a FeatureMobileLayout
 * @returns {JSX}
 * @param {*} props
 */
const FeatureMobileLayout = (props) => {
  const tableName = useSelector((state) => state.app.title);
  const [isOpen, setIsOpen] = useState(false);
  const [isSticky, setIsSticky] = useState(false);
  const [selectedFiltersCount, setSelectedFiltersCount] = useState(0)
  const FeatureMobileLayoutRef = useRef();
  const [errorArray, setErrorArray] = useState([]);
  const jsonData = useSelector( (state) => state.filters.quickFilter );
  const parts = useSelector((state) => state.parts.data);
  const { isReseted } = useSelector((state) => ({
    isReseted: state.qs.isReseted,
  }));

  useEffect(() => {
    if (isReseted){
      setSelectedFiltersCount(0);
    }
  }, [isReseted])

  //useEffect to handle the sticky scroll behaviour
  useEffect(() => {
    /**
     * @name handleScroll
     * @function
     * @description Handles the scroll and sticky behaviour
     */
    const handleScroll = () => {
      const div = FeatureMobileLayoutRef.current;
      if (div) {
        const boundingBox = div.getBoundingClientRect();
        const newIsSticky = boundingBox.top <= 2;
        if (newIsSticky !== isSticky) {
          setIsSticky(newIsSticky);
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [isSticky]);

  const toggleHandler = () => {
    setIsOpen(!isOpen);
  };

  const modalOpen = () => {
    setIsOpen(true);
  };
  const modalClose = () => {
    setIsOpen(false);
  };

  const handleErrorStateChange = (newState) => {
    setErrorArray(newState);
  };
  
  /**
   * @name handleScrollTop
   * @function
   * @description Function that scrolls the user to the Quick Filter section when the button is clicked
   */
  const handleScrollTop = () => {
    if(document.getElementById("pst-feature")){
      document.getElementById("pst-feature").scrollIntoView({behavior: "smooth"});
    }
 }
  return (
    <>
      <div>
        {jsonData && Object.keys(jsonData).length > 0 ? (
          <div>
            <div className="filter-mobile" onClick={modalOpen}>
              <div className="filter-section-mobile">
                <img src={filterIcon} alt="Filter Icon" />
                <div className="filter-title-content">
                  <p className="filter-title">
                    {localization.sortAndFilterLabel}
                  </p>
                  {selectedFiltersCount > 0 && (
                    <p className="applied-filter">
                      {selectedFiltersCount} {localization.filtersApplied}
                    </p>
                  )}
                </div>
              </div>
              <div className="filter-icon">
                <img src={mobileModal} alt="right-arrow" />
              </div>
            </div>
            {isOpen && (
              <div className="filter-modal">
                <div className="filter-modal-top">
                  <p>{localization.sortAndQuickSearch}</p>
                  <img src={closeIcon} alt="close" onClick={modalClose} />
                </div>
                {errorArray.length > 0 ? (
                  <QuickFilterError errorList={errorArray} />
                ) : null}
                <div className="filter-modal-container">
                  <div className="filter-modal-sortBy">
                    <SortBy options={localization.options} mobile />
                  </div>
                </div>
                <QuickFilter
                  mod={props.mod}
                  setMod={props.setMod}
                  setToggle={toggleHandler}
                  closeModal={modalClose}
                  setSelectedFiltersCount={setSelectedFiltersCount}
                  onErrorStateChange={handleErrorStateChange}
                />
              </div>
            )}
          </div>
        ) : (
          <SortBy options={localization.options} mobile renderDeskMarkup />
        )}
      </div>
      <div
        ref={FeatureMobileLayoutRef}
        className={`filterlayout_container ${isSticky ? "sticky" : ""}`}
      >
        {parts.length ? (
          <Tools
            isSticky={isSticky}
            tableName={tableName}
            handleScrollTop={handleScrollTop}
          />
        ) : null}
      </div>
    </>
  );
};

export default FeatureMobileLayout;
